import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MainBudgetingReport  {
    _originalTypeClassName = "zERP.BO.MainBudgetingReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MainBudgetingReport.translate = translateService;
}
this.Expenses = [];
this.Incomes = [];
this.Categories = [];
this.CurrentYear = null;
this.PreviousYear = null;
this.TwoYearsAgo = null;
this.LastPeriod = null;
this.TotalBalance = null;
this.MainBudgetingReportKey = null;
this._key = this.MainBudgetingReportKey = 0; 
}

static translate: TranslateService;
_key: any;
CurrentYear:any;
PreviousYear:any;
TwoYearsAgo:any;
LastPeriod:any;
TotalBalance:any;
Expenses:any;
Budget:any;
Incomes:any;
ExpenseTotals:any;
IncomeTotals:any;
CategoriesTotals:any;
Categories:any;
private _MainBudgetingReportKey:any;
get MainBudgetingReportKey(): any {
    return this._MainBudgetingReportKey;
  }
set MainBudgetingReportKey(value: any) {
    this._MainBudgetingReportKey = value;
    this._key = value;
  }
static setExpenses = ($this, items) => {
                if (items == null) items = [];
                if ($this.Expenses == null) $this.Expenses = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Expenses.length > 0) {
                    Domain.MainBudgetingReport.removeExpenses($this, $this.Expenses[0]);
                }

                Domain.MainBudgetingReport.addManyExpenses($this, copyItems);
            }
static addManyExpenses = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.MainBudgetingReport.addExpenses($this, items[i]);
                }
            }
static addExpenses = ($this, item) => {
                if ($this.Expenses == null) $this.Expenses = [];
                if (item == null || $this.Expenses.indexOf(item) > -1) return;
                $this.Expenses.push(item);
}
static addRangeExpenses = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.MainBudgetingReport.addExpenses($this, item));
            }
static removeExpenses = ($this, item) => {
                if ($this == null || $this.Expenses == null || $this.Expenses.indexOf(item) === -1) return;
                var _index = $this.Expenses.indexOf(item);
                $this.Expenses.splice(_index, 1);
}
static clearExpenses = ($this) => { $this.Expenses = null; }
static setBudget = ($this, value) => {
var oldValue = $this.Budget;
$this.Budget = value;
if (value != null) {
}
}
static setIncomes = ($this, items) => {
                if (items == null) items = [];
                if ($this.Incomes == null) $this.Incomes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Incomes.length > 0) {
                    Domain.MainBudgetingReport.removeIncomes($this, $this.Incomes[0]);
                }

                Domain.MainBudgetingReport.addManyIncomes($this, copyItems);
            }
static addManyIncomes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.MainBudgetingReport.addIncomes($this, items[i]);
                }
            }
static addIncomes = ($this, item) => {
                if ($this.Incomes == null) $this.Incomes = [];
                if (item == null || $this.Incomes.indexOf(item) > -1) return;
                $this.Incomes.push(item);
}
static addRangeIncomes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.MainBudgetingReport.addIncomes($this, item));
            }
static removeIncomes = ($this, item) => {
                if ($this == null || $this.Incomes == null || $this.Incomes.indexOf(item) === -1) return;
                var _index = $this.Incomes.indexOf(item);
                $this.Incomes.splice(_index, 1);
}
static clearIncomes = ($this) => { $this.Incomes = null; }
static setExpenseTotals = ($this, value) => {
var oldValue = $this.ExpenseTotals;
$this.ExpenseTotals = value;
if (value != null) {
}
}
static setIncomeTotals = ($this, value) => {
var oldValue = $this.IncomeTotals;
$this.IncomeTotals = value;
if (value != null) {
}
}
static setCategoriesTotals = ($this, value) => {
var oldValue = $this.CategoriesTotals;
$this.CategoriesTotals = value;
if (value != null) {
}
}
static setCategories = ($this, items) => {
                if (items == null) items = [];
                if ($this.Categories == null) $this.Categories = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Categories.length > 0) {
                    Domain.MainBudgetingReport.removeCategories($this, $this.Categories[0]);
                }

                Domain.MainBudgetingReport.addManyCategories($this, copyItems);
            }
static addManyCategories = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.MainBudgetingReport.addCategories($this, items[i]);
                }
            }
static addCategories = ($this, item) => {
                if ($this.Categories == null) $this.Categories = [];
                if (item == null || $this.Categories.indexOf(item) > -1) return;
                $this.Categories.push(item);
}
static addRangeCategories = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.MainBudgetingReport.addCategories($this, item));
            }
static removeCategories = ($this, item) => {
                if ($this == null || $this.Categories == null || $this.Categories.indexOf(item) === -1) return;
                var _index = $this.Categories.indexOf(item);
                $this.Categories.splice(_index, 1);
}
static clearCategories = ($this) => { $this.Categories = null; }

static FillCategoriesTotals(data: any): any{let cT = new Domain.MainBudgetingReportLine();
cT.BudgetingAmount2 = Joove.Common.safeNumber(data?.IncomeTotals?.BudgetingAmount2) - Joove.Common.safeNumber(data?.ExpenseTotals?.BudgetingAmount2);
cT.ActualAmount2 = Joove.Common.safeNumber(data?.IncomeTotals?.ActualAmount2) - Joove.Common.safeNumber(data?.ExpenseTotals?.ActualAmount2);
cT.BudgetingAmount1 = Joove.Common.safeNumber(data?.IncomeTotals?.BudgetingAmount1) - Joove.Common.safeNumber(data?.ExpenseTotals?.BudgetingAmount1);
cT.ActualAmount1 = Joove.Common.safeNumber(data?.IncomeTotals?.ActualAmount1) - Joove.Common.safeNumber(data?.ExpenseTotals?.ActualAmount1);
cT.BudgetingAmount = Joove.Common.safeNumber(data?.IncomeTotals?.BudgetingAmount) - Joove.Common.safeNumber(data?.ExpenseTotals?.BudgetingAmount);
cT.ActualAmount = Joove.Common.safeNumber(data?.IncomeTotals?.ActualAmount) - Joove.Common.safeNumber(data?.ExpenseTotals?.ActualAmount);
cT.BudgetingDifference = (CLMS.Framework.Number.Equal(() => cT.BudgetingAmount1, () => 0) ? 0 : Joove.Common.safeNumber((Joove.Common.safeNumber(cT?.BudgetingAmount2) - Joove.Common.safeNumber(cT?.BudgetingAmount1))) / Joove.Common.safeNumber(cT?.BudgetingAmount1));
cT.TotalAdjustmentAmount = Joove.Common.safeNumber(data?.IncomeTotals?.TotalAdjustmentAmount) - Joove.Common.safeNumber(data?.ExpenseTotals?.TotalAdjustmentAmount);
return cT;
}
static UpdateExpenseTotals(data: any,line: any): any{let interimResult = new Domain.MainBudgetingReportLine();
interimResult.BudgetingAmount2 = Joove.Common.safeNumber(data?.ExpenseTotals?.BudgetingAmount2) + Joove.Common.safeNumber(line?.BudgetingAmount2);
interimResult.ActualAmount2 = Joove.Common.safeNumber(data?.ExpenseTotals?.ActualAmount2) + Joove.Common.safeNumber(line?.ActualAmount2);
interimResult.BudgetingAmount1 = Joove.Common.safeNumber(data?.ExpenseTotals?.BudgetingAmount1) + Joove.Common.safeNumber(line?.BudgetingAmount1);
interimResult.ActualAmount1 = Joove.Common.safeNumber(data?.ExpenseTotals?.ActualAmount1) + Joove.Common.safeNumber(line?.ActualAmount1);
interimResult.BudgetingAmount = Joove.Common.safeNumber(data?.ExpenseTotals?.BudgetingAmount) + Joove.Common.safeNumber(line?.BudgetingAmount);
interimResult.ActualAmount = Joove.Common.safeNumber(data?.ExpenseTotals?.ActualAmount) + Joove.Common.safeNumber(line?.ActualAmount);
interimResult.AccountingCharge = Joove.Common.safeNumber(data?.ExpenseTotals?.AccountingCharge) + Joove.Common.safeNumber(line?.AccountingCharge);
interimResult.AccountingCredit = Joove.Common.safeNumber(data?.ExpenseTotals?.AccountingCredit) + Joove.Common.safeNumber(line?.AccountingCredit);
interimResult.RequestedIncreaseAmount = Joove.Common.safeNumber(data?.ExpenseTotals?.RequestedIncreaseAmount) + Joove.Common.safeNumber(line?.RequestedIncreaseAmount);
interimResult.RequestedDecreaseAmount = Joove.Common.safeNumber(data?.ExpenseTotals?.RequestedDecreaseAmount) + Joove.Common.safeNumber(line?.RequestedDecreaseAmount);
interimResult.TotalAdjustmentAmount = Joove.Common.safeNumber(data?.ExpenseTotals?.TotalAdjustmentAmount) + Joove.Common.safeNumber(line?.TotalAdjustmentAmount);
return interimResult;
}
static UpdateIncomeTotals(data: any,line: any): any{let interimResult = new Domain.MainBudgetingReportLine();
interimResult.BudgetingAmount2 = Joove.Common.safeNumber(data?.IncomeTotals?.BudgetingAmount2) + Joove.Common.safeNumber(line?.BudgetingAmount2);
interimResult.ActualAmount2 = Joove.Common.safeNumber(data?.IncomeTotals?.ActualAmount2) + Joove.Common.safeNumber(line?.ActualAmount2);
interimResult.BudgetingAmount1 = Joove.Common.safeNumber(data?.IncomeTotals?.BudgetingAmount1) + Joove.Common.safeNumber(line?.BudgetingAmount1);
interimResult.ActualAmount1 = Joove.Common.safeNumber(data?.IncomeTotals?.ActualAmount1) + Joove.Common.safeNumber(line?.ActualAmount1);
interimResult.BudgetingAmount = Joove.Common.safeNumber(data?.IncomeTotals?.BudgetingAmount) + Joove.Common.safeNumber(line?.BudgetingAmount);
interimResult.ActualAmount = Joove.Common.safeNumber(data?.IncomeTotals?.ActualAmount) + Joove.Common.safeNumber(line?.ActualAmount);
interimResult.AccountingCharge = Joove.Common.safeNumber(data?.IncomeTotals?.AccountingCharge) + Joove.Common.safeNumber(line?.AccountingCharge);
interimResult.AccountingCredit = Joove.Common.safeNumber(data?.IncomeTotals?.AccountingCredit) + Joove.Common.safeNumber(line?.AccountingCredit);
interimResult.RequestedIncreaseAmount = Joove.Common.safeNumber(data?.IncomeTotals?.RequestedIncreaseAmount) + Joove.Common.safeNumber(line?.RequestedIncreaseAmount);
interimResult.RequestedDecreaseAmount = Joove.Common.safeNumber(data?.IncomeTotals?.RequestedDecreaseAmount) + Joove.Common.safeNumber(line?.RequestedDecreaseAmount);
interimResult.TotalAdjustmentAmount = Joove.Common.safeNumber(data?.IncomeTotals?.TotalAdjustmentAmount) + Joove.Common.safeNumber(line?.TotalAdjustmentAmount);
return interimResult;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MainBudgetingReportKey == null || $this.MainBudgetingReportKey == 0;
            }


}